import * as R from 'ramda';
import * as Yup from 'yup';
import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../../components/form-footer';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// forms
import { Fieldset2 } from '../../../../forms';
// ui
import { Box } from '../../../../ui';
// feature dispatch-report
import * as LC from '../../constants';
//////////////////////////////////////////////////

export const validationSchema = Yup.object().shape({
  [LC.FIELD_CLO_GUID]: Yup.string()
    .nullable(true)
    .required(G.getRequiredLocaleTxt()),
  [LC.FIELD_TEMPLATE_NAME]: Yup.string()
    .nullable(true)
    .required(G.getRequiredLocaleTxt()),
  [LC.FIELD_TEL_CREATION_MODE]: Yup.string()
    .nullable(true)
    .required(G.getRequiredLocaleTxt()),
  [LC.FIELD_RETAINED_REFERENCES]: Yup.array()
    .notRequired()
    .nullable(true),
});

const defaultFormikValues = {
  [LC.FIELD_CLO_GUID]: null,
  [LC.FIELD_TEMPLATE_NAME]: null,
  [LC.FIELD_TEL_CREATION_MODE]: null,
  [LC.FIELD_RETAINED_REFERENCES]: null,
};

const inputWrapperStyles = {
  mb: 25,
  width: 300,
};

const fields = [
  {
    type: 'text',
    isRequired: true,
    inputWrapperStyles,
    label: ['titles:template-name'],
    fieldName: LC.FIELD_TEMPLATE_NAME,
  },
  {
    type: 'select',
    inputWrapperStyles,
    label: ['titles:tel-creation-mode'],
    fieldName: LC.FIELD_TEL_CREATION_MODE,
    options: [
      {
        value: GC.TEL_CREATION_MODE_NO_TEL,
        label: G.getWindowLocale('titles:no-tel', 'No TEL'),
      },
      {
        value: GC.TEL_CREATION_MODE_SINGLE_TEL,
        label: G.getWindowLocale('titles:single-tel', 'Single TEL'),
      },
    ],
  },
  {
    isMulti: true,
    inputWrapperStyles,
    type: 'reactSelect',
    options: 'referenceTypeOptions',
    label: ['titles:retained-references'],
    fieldName: LC.FIELD_RETAINED_REFERENCES,
  },
];

const enhance = compose(
  withFormik({
    validationSchema,
    enableReinitialize: true,
    displayName: 'CREATE_LOAD_TEMPLATE_FORM',
    handleSubmit: (values, { props }) => props.handleSubmitForm(values),
    mapPropsToValues: (props) => R.mergeRight(defaultFormikValues, props.initialValues),
  }),
  pure,
);

export const OrderTemplateForm = enhance((props) => (
  <form onSubmit={props.handleSubmit}>
    <Fieldset2
      {...props}
      fields={fields}
      onChange={props.handleChange}
      fieldsWrapperStyles={{ pt: 10 }}
    />
    <FormFooter />
  </form>
));
